import { Facebook, Instagram } from '@mui/icons-material';
import { AppBar, Button, Container, Grid2 as Grid, Link, Menu, MenuItem } from '@mui/material';
import { useState } from 'react';

export default function AccountMenu() {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const goToRoute = (url: string) => {
        window.location.href = url;
    }

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = (opt: number) => {
        setAnchorEl(null);
        if (opt > 0) {
            const category = "/articles/category/"
            goToRoute(category + opt);
        }

    };
    const buttonColSize = 100;

    const goToUrl = (url: string) => {
        window.location.href = url;
    }

    return (
        <>
            <AppBar position="static">
                <Container maxWidth="xl">
                    {/* <Toolbar disableGutters> */}
                    <Grid container spacing={3}>
                        <Grid size={1} minWidth={50}>
                            <Link
                                onClick={() => goToUrl('https://www.facebook.com/share/16poYwUUkS/')}>
                                <Facebook color='warning' />
                            </Link>
                            <Link
                                onClick={() => goToUrl('https://www.instagram.com/superfun_party_rental?igsh=MWgzaG1mY2tjcWgxeA%3D%3D&utm_source=qr ')}>
                                <Instagram color='warning' />
                            </Link>
                        </Grid>
                        <Grid size={5} minWidth={250} >
                            <div style={{ textAlign: 'center' }}>
                                <Link href={"/"}>
                                    <img src={'/super_fun.jpg'} alt='super fun logo' style={{ width: '70%', maxWidth: '80px', borderRadius: 60 }} />
                                </Link>
                            </div>
                        </Grid>
                        <Grid size={2} minWidth={buttonColSize}>
                            <Button
                                id="basic-button"
                                aria-controls={open ? 'basic-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={open ? 'true' : undefined}
                                variant='contained'
                                onClick={handleClick}
                            >
                                Inflatables
                            </Button>
                            <Menu
                                id="basic-menu"
                                anchorEl={anchorEl}
                                open={open}
                                onClose={() => handleClose(0)}
                            >
                                <MenuItem onClick={() => handleClose(1)}>RENT AN INFLATABLE</MenuItem>
                                <MenuItem onClick={() => handleClose(2)}>BUY AN INFLATABLE</MenuItem>
                            </Menu>
                        </Grid>
                        <Grid size={2} minWidth={buttonColSize}>
                            <Button
                                id="basic-button"
                                aria-haspopup="true"
                                variant='contained'
                                onClick={() => handleClose(3)}                        >
                                PARTY EQUIPMENT
                            </Button>
                        </Grid>
                        <Grid size={2} minWidth={buttonColSize}>
                            <Button
                                id="basic-button"
                                aria-controls={open ? 'basic-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={open ? 'true' : undefined}
                                variant='contained'
                                onClick={() => goToRoute('/contactUs')}
                            >Contact US</Button>
                        </Grid>
                    </Grid>
                    {/* </Toolbar> */}
                </Container>
            </AppBar>
        </>
    );
}
